module.exports = __webpack_public_path__ + "img/web_asset.d8f4fa3e.svg";